import { skipToken, useQuery } from '@tanstack/react-query';
import * as React from 'react';

import type { Integration, IntegrationBlock } from '@gitbook/api-client';
import { createIntegrationsBlocksSet, getIntegrationBlockForURL } from '@gitbook/app-database';

import { apiQuery, useAssertCurrentOrganizationId } from '../../../state';

/**
 * Get an integration that has a block matching a specific url.
 */
export function useIntegrationForURL(url: string | null):
    | undefined
    | {
          integration: Integration;
          block: IntegrationBlock;
      } {
    const domain = url ? new URL(url).hostname : null;

    const organizationId = useAssertCurrentOrganizationId();
    const { data } = useQuery(
        apiQuery(
            'listOrganizationIntegrations',
            domain ? { organizationId, blockDomain: domain } : skipToken,
            {
                // Refactor: handle the error case in a react boundary
                nullOnError: true,
            }
        )
    );

    return React.useMemo(() => {
        if (!data || !url) {
            return undefined;
        }

        const match = getIntegrationBlockForURL(createIntegrationsBlocksSet(data.items), url);
        if (!match) {
            return undefined;
        }

        const integration = data.items.find((i) => i.name === match.integrationKey);
        if (!integration) {
            return undefined;
        }

        return { integration, block: match.block };
    }, [data, url]);
}
